import axios from 'axios';
import Util from '../Util'

class BookmarkAPI {

    constructor() {
        this.apiHost = process.env.VUE_APP_API_HOST;
    }

    listBookmark(){
        let path = "/api/bookmarks/_self";
        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));
        return axios.get(endpoint, {}).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }

    putBookmark(reportId){
        let path = "/api/bookmarks/_self/" + reportId;
        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));
        return axios.put(endpoint, {}).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }

    deleteBookmark(reportId){
        let path = "/api/bookmarks/_self/" + reportId;
        let endpoint =  Util.combineUrl(this.apiHost, Util.buildApiPath(path));
        return axios.delete(endpoint, {}).then(response => Util.addSnakeCaseAliasesDeep(Util.toCamelCaseDeep(response.data)))
    }


}

let _api = new BookmarkAPI();

export default _api;